import Switch from 'react-switch';
import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ExtraInningRulesStore } from 'stores/Tagging/ExtraInningRulesStore';
import { SessionStore } from 'stores/SessionStore';
import { InningRuleToggle, Label } from './styles/SmallExtraInningSwitch';

const SmallExtraInningRuleSwitch = observer(() => {
  const extraInningRuleStore = useInjection<ExtraInningRulesStore>(ServiceTypes.ExtraInningRulesStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);

  const changeHandler = (checked: boolean): void => {
    extraInningRuleStore.setIsExtraRunnerEnabled(checked);
  };

  useEffect(() => {
    const gameLevels = ['MLB', 'AAA', 'AA', 'HighA', 'LowA'];
    if (
      sessionStore.currentSessionMetadata.level &&
      sessionStore.currentSessionMetadata.level.name &&
      gameLevels.includes(sessionStore.currentSessionMetadata.level.name)
    ) {
      extraInningRuleStore.setIsExtraRunnerEnabled(true);
    }
  }, []);

  return (
    <InningRuleToggle>
      <Label>Extra runner</Label>
      <Switch
        checked={extraInningRuleStore.isExtraRunnerEnabled}
        onChange={changeHandler}
        onColor='#ec691a'
        checkedIcon={false}
        uncheckedIcon={false}
        height={24.8}
        width={40.8}
      />
    </InningRuleToggle>
  );
});

export default SmallExtraInningRuleSwitch;
